import React from "react";
import ImageUpload from "shared/components/inputs/ImageUpload";

import FsInput from "./FsInput";

export default class FsImageUpload extends FsInput {
  getValueFromUpdate(event) {
    if (!event) {
      return null;
    }
    return super.getValueFromUpdate(event);
  }

  toggleSubmitButton(value) {
    this.props.formState.isSubmitButtonDisabled = value;
    this.props.formState.renderCallback();
  }

  renderInput() {
    const { formState, attribute, name, hasAServerValue } = this.props;
    const { children } = this.props; // FIXME use endpoint api

    return (
      <ImageUpload
        startups
        name={name || attribute}
        value={formState.readFormAttribute(attribute)}
        hasAServerValue={hasAServerValue}
        onChange={this.update.bind(this)}
        toggleSubmit={this.toggleSubmitButton.bind(this)}
      >
        {children}
      </ImageUpload>
    );
  }
}
